var _path, _path2, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegratedGraphics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0941 18.6641L30.0005 27.2585L30.9068 18.6641H29.0941ZM30.9046 41.0607L29.9983 32.4662L29.0919 41.0607H30.9046ZM27.3841 29.8612L18.75 30.7634V28.959L27.3841 29.8612ZM41.2488 28.9612L32.6147 29.8634L41.2488 30.7655V28.9612ZM28.1506 31.7031L22.6862 38.4182L21.4045 37.1423L28.1506 31.7031ZM37.3122 21.3062L31.8478 28.0213L38.594 22.582L37.3122 21.3062ZM31.8492 31.7031L38.5953 37.1424L37.3136 38.4182L31.8492 31.7031ZM21.4034 22.5822L28.1496 28.0215L22.6852 21.3063L21.4034 22.5822ZM28.9785 32.2605L26.4452 40.5261L24.7761 39.8223L28.9785 32.2605ZM33.5536 19.1983L31.0203 27.4639L35.2227 19.9021L33.5536 19.1983ZM27.5901 28.8459L19.2864 26.3243L19.9934 24.6628L27.5901 28.8459ZM40.7124 33.4003L32.4087 30.8787L40.0054 35.0617L40.7124 33.4003ZM27.5726 30.8402L19.9097 34.9018L19.2294 33.2293L27.5726 30.8402ZM40.0891 24.8228L32.4262 28.8844L40.7694 26.4952L40.0891 24.8228ZM30.9816 32.275L35.062 39.9027L33.3818 40.5799L30.9816 32.275ZM24.9364 19.8217L29.0168 27.4494L26.6166 19.1445L24.9364 19.8217Z",
    fill: "#00C7FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6979 32.5779C7.1007 31.1833 7.1007 28.8168 8.6979 27.4222C11.2139 25.2253 14.709 22.4523 18.5297 20.2361C22.3806 18.0024 26.3991 16.4312 30 16.4312C33.6009 16.4312 37.6194 18.0024 41.4703 20.2361C45.291 22.4523 48.7861 25.2253 51.3021 27.4222C52.8993 28.8168 52.8993 31.1833 51.3021 32.5779C48.7861 34.7749 45.291 37.5479 41.4703 39.7641C37.6194 41.9977 33.6009 43.569 30 43.569C26.3991 43.569 22.3806 41.9977 18.5297 39.7641C14.709 37.5479 11.2139 34.7749 8.6979 32.5779Z",
    stroke: "url(#paint0_linear_348_13705)",
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 28.6677,
    width: 2.4,
    height: 2.38897,
    fill: "#00C7FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_348_13705",
    x1: 17.25,
    y1: 29.489,
    x2: 7.5,
    y2: 29.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C7FD",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegratedGraphics);
export default __webpack_public_path__ + "static/media/integrated_graphics.74bf07b465280dfbc8c600b27ab38b06.svg";
export { ForwardRef as ReactComponent };